import LocalizedStrings from "react-localization";

export const strings = new LocalizedStrings({
  fi: {
    header: ["Minusta", "Yhteystiedot", "Valikoima"],
  },
});
